export enum OrderStatus {
  Open = 0,
  Closed = 1,
  Canceled = 2,
  // An open order holding an item blocked from sale (an asterisk in its description). It cannot
  // pass Stage 2A: Release Order and Notify are refused. The ERP push sets and clears it.
  OnHold = 3,
}

export enum OrderStatusString {
  Open = '0',
  Closed = '1',
  Canceled = '2',
  OnHold = '3',
}

// The order's Props carry Status by its C# name. Anything unrecognised reads as Canceled, the
// read-only state, as the per-component ternaries this replaced did.
export function orderStatusFromName(name: string | null | undefined): OrderStatus {
  switch (name) {
    case 'Open':
      return OrderStatus.Open;
    case 'Closed':
      return OrderStatus.Closed;
    case 'OnHold':
      return OrderStatus.OnHold;
    default:
      return OrderStatus.Canceled;
  }
}

export function orderStatusLabel(status: OrderStatus): string {
  switch (status) {
    case OrderStatus.Open:
      return 'Open';
    case OrderStatus.Closed:
      return 'Closed';
    case OrderStatus.OnHold:
      return 'On Hold';
    default:
      return 'Canceled';
  }
}
